// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  actions: "SectionQuiz__actions",
  artColumn: "SectionQuiz__artColumn",
  bounded: "SectionQuiz__bounded",
  category: "SectionQuiz__category",
  centred: "SectionQuiz__centred",
  column: "SectionQuiz__column",
  consentActions: "SectionQuiz__consentActions",
  context: "SectionQuiz__context",
  controlSlot: "SectionQuiz__controlSlot",
  count: "SectionQuiz__count",
  cover: "SectionQuiz__cover",
  coverFeather: "SectionQuiz__coverFeather",
  explorerInStage: "SectionQuiz__explorerInStage",
  eyebrow: "SectionQuiz__eyebrow",
  grid: "SectionQuiz__grid",
  head: "SectionQuiz__head",
  icon: "SectionQuiz__icon",
  introStage: "SectionQuiz__introStage",
  next: "SectionQuiz__next",
  primary: "SectionQuiz__primary",
  prompt: "SectionQuiz__prompt",
  "result-swap": "SectionQuiz__result-swap",
  resultAnswer: "SectionQuiz__resultAnswer",
  resultAnswerLabel: "SectionQuiz__resultAnswerLabel",
  resultAnswerValue: "SectionQuiz__resultAnswerValue",
  resultAnswers: "SectionQuiz__resultAnswers",
  resultArt: "SectionQuiz__resultArt",
  resultExpanded: "SectionQuiz__resultExpanded",
  resultEyebrow: "SectionQuiz__resultEyebrow",
  resultFamily: "SectionQuiz__resultFamily",
  resultFigure: "SectionQuiz__resultFigure",
  resultHeadline: "SectionQuiz__resultHeadline",
  resultIntro: "SectionQuiz__resultIntro",
  resultLeft: "SectionQuiz__resultLeft",
  resultNote: "SectionQuiz__resultNote",
  resultPortrait: "SectionQuiz__resultPortrait",
  resultRight: "SectionQuiz__resultRight",
  resultStage: "SectionQuiz__resultStage",
  resultWide: "SectionQuiz__resultWide",
  section: "SectionQuiz__section",
  skip: "SectionQuiz__skip",
  stage: "SectionQuiz__stage",
  standfirst: "SectionQuiz__standfirst",
  tertiary: "SectionQuiz__tertiary",
  title: "SectionQuiz__title",
};
